import { useRef, useState } from "react";
import { UploadCloud, FileText, X } from "lucide-react";

export function FileDrop({ label, hint = "PDF, DOCX o TXT · Máx. 25 MB", multiple = false, value, onChange, testid }) {
  const inputRef = useRef(null);
  const [drag, setDrag] = useState(false);
  const files = multiple ? value || [] : value ? [value] : [];

  const handleFiles = (list) => {
    const arr = Array.from(list);
    if (multiple) onChange([...(value || []), ...arr]);
    else onChange(arr[0] || null);
  };

  const remove = (idx) => {
    if (multiple) onChange((value || []).filter((_, i) => i !== idx));
    else onChange(null);
  };

  return (
    <div>
      {label && <label className="ddp-label">{label}</label>}
      <div
        role="button"
        tabIndex={0}
        data-testid={testid}
        onClick={() => inputRef.current?.click()}
        onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && inputRef.current?.click()}
        onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
        onDragLeave={() => setDrag(false)}
        onDrop={(e) => { e.preventDefault(); setDrag(false); handleFiles(e.dataTransfer.files); }}
        style={{
          border: `1.5px dashed ${drag ? "var(--burgundy-med)" : "var(--line)"}`,
          background: drag ? "#F3E7E8" : "var(--paper-2)",
          borderRadius: 7,
          padding: "22px 20px",
          cursor: "pointer",
          transition: "all .15s ease",
          textAlign: "center",
        }}
      >
        <UploadCloud size={26} style={{ color: "var(--burgundy-med)", margin: "0 auto 8px" }} />
        <div style={{ fontSize: 13, color: "var(--ink)", fontWeight: 600 }}>
          Arrastre el archivo aquí o haga clic para seleccionar
        </div>
        <div style={{ fontSize: 12, color: "var(--muted)", marginTop: 4 }}>{hint}</div>
        <input
          ref={inputRef}
          type="file"
          multiple={multiple}
          accept=".pdf,.docx,.txt"
          style={{ display: "none" }}
          onChange={(e) => handleFiles(e.target.files)}
        />
      </div>
      {files.length > 0 && (
        <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 7 }}>
          {files.map((f, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, background: "var(--paper)", border: "1px solid var(--line)", borderRadius: 5, padding: "9px 12px" }}>
              <FileText size={16} style={{ color: "var(--burgundy)" }} />
              <span style={{ flex: 1, fontSize: 13, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{f.name}</span>
              <span style={{ fontSize: 12, color: "var(--muted)" }}>{(f.size / 1024 / 1024).toFixed(1)} MB</span>
              <button type="button" onClick={(e) => { e.stopPropagation(); remove(i); }} style={{ border: 0, background: "transparent", cursor: "pointer", color: "var(--muted)" }}>
                <X size={16} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
